import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ac707d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "particulars",
  ref: "particulars"
}
const _hoisted_2 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Defualt = _resolveComponent("Defualt")!
  const _component_History = _resolveComponent("History")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Modal, {
      getContainer: () => _ctx.$refs.particulars,
      title: _ctx.titles,
      placement: "right",
      width: '9rem',
      centered: "",
      footer: false,
      visible: _ctx.particularsVisible,
      onCancel: _ctx.close
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createVNode(_component_Defualt, {
            ticketDetail: _ctx.ticketDetail,
            onChangeDetail: _ctx.changeDetail
          }, null, 8, ["ticketDetail", "onChangeDetail"]), [
            [_vShow, _ctx.action!=='created']
          ]),
          _withDirectives(_createVNode(_component_History, { data: _ctx.ticketDetail }, null, 8, ["data"]), [
            [_vShow, _ctx.action!=='created' && _ctx.action !== 'designate']
          ])
        ])
      ]),
      _: 1
    }, 8, ["getContainer", "title", "visible", "onCancel"])
  ], 512))
}